




























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import StepTapes from './requirement/StepTapes.vue';
import StepTapeManagementTicketConfirmation from './tape-management/StepTapeManagementTicketConfirmation.vue';
import TapeManagementGeneralInformation from './tape-management/TapeManagementGeneralInformation.vue';
import ticketsRepository from '../../../modules/tickets/shared/repositories/tickets.repository';
import { GET_CUSTOMER_ID } from '@/modules/users/store/user.getters';
import { user } from '@/modules/shared/shared/store/namespaces';
import {
    Tickets,
    TicketType,
    TapeChangeType,
} from '@/modules/shared/shared/domain/constants/constants';
import { mapMutations } from 'vuex';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({
    components: {
        TicketGeneralInformation: TapeManagementGeneralInformation,
        TicketRequirementStepOne: StepTapes,
        TicketRequirementStepTwo: StepTapeManagementTicketConfirmation,
    },
    methods: {
        ...mapMutations('layout', ['changeTitle']),
    },
})
export default class TicketsTapeManagement extends Vue {
    errorLoadingContent: boolean = false;
    valid: boolean = false;
    highestStepReached: number = 1;
    currentStep: number = 1;
    creatingTicket: boolean = false;
    requiresTapes: boolean = false;
    formValues: {
        generalInformation: {
            contactId: number;
            firstName: string;
            lastName: string;
            idNumber: string;
            telephoneNumber: string;
            description: string;
        };
        typings: {
            id: number;
            name: string;
            status: number;
            typing: number;
        }[];
    } = {
        generalInformation: {
            contactId: 0,
            firstName: '',
            lastName: '',
            idNumber: '',
            telephoneNumber: '',
            description: '',
        },
        typings: [],
    };
    requirementTicket: {
        generalInformation: {
            subject: number;
            textSubject: string;
            contactId: number;
            firstName: string;
            lastName: string;
            idNumber: string;
            telephoneNumber: string;
            description: string;
        };
        tapes: {
            giveOrTake: string;
            code: string;
        }[];
    } = {
        generalInformation: {
            subject: 0,
            textSubject: '',
            contactId: 0,
            firstName: '',
            lastName: '',
            idNumber: '',
            telephoneNumber: '',
            description: '',
        },
        tapes: Array(),
    };
    $refs!: {
        form: any;
        Step1: any;
        Step2: any;
    };

    nextStep() {
        if (this.currentStep < 3) {
            this.currentStep++;
            this.highestStepReached = this.currentStep;

            if (this.currentStep == 3) {
                this.requestData();
            }
            if (this.currentStep == 2 && !this.requiresTapes) {
                this.nextStep();
            }
        }
    }

    enableTapeStep(motive: number) {
        if (motive === Tickets.REQUIREMENT.typings.tapeChange.id) {
            this.requiresTapes = true;
        } else {
            this.requiresTapes = false;
        }
    }

    getTapeDelivery() {
        const tapeChanges = Array();
        Array.from(this.requirementTicket.tapes).forEach(tape => {
            tapeChanges.push({
                tapeCode: tape.code,
                tapeDeliveryChangeType: {
                    id:
                        tape.giveOrTake === TapeChangeType.GIVE.name
                            ? TapeChangeType.GIVE.id
                            : TapeChangeType.TAKE.id,
                },
            });
        });

        const tapeDelivery = {
            user: {
                id: this.user.id,
            },
            tapeChanges,
        };

        return tapeDelivery;
    }

    async sendRequirementTicket() {
        let stepNumbers = [1];
        let incompleteSteps = Array();

        stepNumbers.forEach(number => {
            if (this.$refs['Step' + number].$refs.form.validate() == false) {
                incompleteSteps.push(number);
            }
        });

        if (incompleteSteps.length > 0) {
            this.currentStep = Math.min(...incompleteSteps);
        } else {
            if (this.currentStep != 3) {
                this.currentStep = 3;
            } else {
                const mappedTapeManagementTicket = {
                    description: this.requirementTicket.generalInformation.description,
                    typing: {
                        id: this.requirementTicket.generalInformation.subject,
                        name: this.requirementTicket.generalInformation.textSubject,
                    },
                    ticketType: {
                        id: Tickets.REQUIREMENT.id,
                        name: TicketType.TAPE,
                    },
                    tapeDelivery: this.requiresTapes ? this.getTapeDelivery() : false,
                    customer: {
                        id: this.contact.customer.id,
                        name: this.contact.customer.name,
                        category: {
                            id: this.contact.customer.category.id,
                        },
                        contact: {
                            id: this.requirementTicket.generalInformation.contactId,
                            name: this.requirementTicket.generalInformation.firstName,
                            lastName: this.requirementTicket.generalInformation.lastName,
                            email: this.contact.email,
                            ci: this.requirementTicket.generalInformation.idNumber,
                        },
                    },
                };

                try {
                    EventBus.$emit(EventBusMessages.SHOW_LOADER);

                    const response = await ticketsRepository.createTicket(
                        mappedTapeManagementTicket,
                    );
                    this.$router.push({
                        name: 'tickets',
                        params: { ticket: 'success', id: response.data.id },
                    });

                    EventBus.$emit(EventBusMessages.HIDE_LOADER);
                } catch (ex) {
                    EventBus.$emit(EventBusMessages.HIDE_LOADER);
                    this.$router.push({ name: 'tickets', params: { ticket: 'error' } });
                }

                this.creatingTicket = false;
            }
        }
    }

    previousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    requestData() {
        const stepNumbers = [1];

        if (this.requiresTapes) {
            stepNumbers.push(2);
        } else {
            this.requirementTicket.tapes = Array();
        }

        stepNumbers.forEach(number => {
            Object.assign(this.requirementTicket, this.$refs['Step' + number].sendData());
        });

        this.formValues.typings.forEach(element => {
            if (element.id === this.requirementTicket.generalInformation.subject) {
                this.requirementTicket.generalInformation.textSubject = element.name;
            }
        });
    }

    @Watch('currentStep')
    debugFunction(value: any, oldValue: any) {
        if (this.currentStep == 3) {
            this.requestData();
        }
    }

    getTapeManagementTypingSelected(value: number) {
        this.requirementTicket.generalInformation.subject = value;

        if (value == Tickets.REQUIREMENT.typings.tapeChange.id) {
            this.requiresTapes = true;
        } else {
            this.requiresTapes = false;
        }
    }

    async mounted() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        //@ts-ignore
        this.changeTitle({ title: 'Requerimiento de Gestión de Cintas', route: ['TICKETS'] });

        this.formValues.generalInformation.contactId = this.contact.id;
        this.formValues.generalInformation.firstName = this.contact.name;
        this.formValues.generalInformation.lastName = this.contact.lastName;
        this.formValues.generalInformation.idNumber = this.contact.ci;
        this.formValues.generalInformation.telephoneNumber = this.contact.phone;

        try {
            const customerId: number = this.GET_CUSTOMER_ID;
            const response = await ticketsRepository.getDataCreateTicket(
                customerId,
                TicketType.TAPE,
            );
            this.formValues.typings = response.data.values.typings;
        } catch (ex) {
            this.errorLoadingContent = true;
        }

        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    @user.State('contact') contact;
    @user.State('user') user;
    @user.Getter(GET_CUSTOMER_ID) GET_CUSTOMER_ID;
}
